import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import API from '../api/api';
import { AlertType, Input, ChatMessages } from '../types/common';
import { showAlert } from './CommonSlice';
import { RootState } from './store';
import { initUser } from './UserSlice';

type ConversationSlice = {
  messages: ChatMessages;
  isConversationLoading: boolean;
};

const initialState: ConversationSlice = {
  messages: [],
  isConversationLoading: false,
};

export const getConversation = createAsyncThunk('conversation/getConversation', async (_: void, { dispatch }) => {
  try {
    dispatch(setIsConversationLoading(true));

    const polling = async () => {
      const { status, messages } = await API.getConversation();
      if (status === 'done') {
        dispatch(setConversation(messages));
        dispatch(initUser());
        dispatch(setIsConversationLoading(false));
      } else {
        if (status === 'error') {
          dispatch(setIsConversationLoading(false));
          throw new Error('polling got error');
        }
        setTimeout(polling, 3000);
      }
    };

    await polling();
  } catch (e: any) {
    dispatch(showAlert({ type: AlertType.Error, message: 'Что-то пошло не так' }));
    console.log('getConversation error:', e);
  }
});

export const sendConversationMessage = createAsyncThunk<void, Input, { state: RootState }>(
  'conversation/sendConversationMessage',
  async (message: Input, { dispatch, getState }) => {
    try {
      dispatch(setIsConversationLoading(true));
      const { status, messages } = await API.sendConversationMessage({ ...message });
      if (status === 'error') {
        dispatch(setIsConversationLoading(false));
        throw new Error('message creation got error');
      }
      dispatch(setConversation(messages));
      dispatch(getConversation());
    } catch (e: any) {
      dispatch(setIsConversationLoading(false));
      if (e?.status === 402) {
        dispatch(showAlert({ type: AlertType.Error, message: 'Недостаточно кредитов на счету' }));
        console.log('sendConversationMessage error:', e);
        dispatch(initUser());
        return;
      }
      dispatch(showAlert({ type: AlertType.Error, message: 'Что-то пошло не так' }));
      console.log('sendConversationMessage error:', e);
    }
  }
);

export const deleteConversation = createAsyncThunk('conversation/deleteConversation', async (_: void, { dispatch }) => {
  try {
    dispatch(setIsConversationLoading(true));
    const { status, messages } = await API.deleteConversation();
    dispatch(setConversation(messages));
    if (status === 'error') {
      throw new Error('chat removal got error');
    }
  } catch (e: any) {
    dispatch(showAlert({ type: AlertType.Error, message: 'Что-то пошло не так' }));
    console.log('getConversation error:', e);
  }
  dispatch(setIsConversationLoading(false));
});

export const conversationSlice = createSlice({
  name: 'conversation',
  initialState,
  reducers: {
    setIsConversationLoading: (state, { payload }: { payload: boolean }) => {
      state.isConversationLoading = payload;
    },

    setConversation: (state, action: PayloadAction<ChatMessages>) => {
      state.messages = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { setIsConversationLoading, setConversation } = conversationSlice.actions;

export default conversationSlice.reducer;
